import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, MenuItem, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { IGlobalSearchParam } from '../../../../app/shared/models/Global-Search.model';
import { ClientCheckListsService } from '../../services';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IClientCheckLists } from '../../models';
import { SharedService } from '../../../shared/services/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { JwtService } from 'src/app/auth/services';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-client-checklists',
  templateUrl: './client-checklists.component.html',
  styleUrls: ['./client-checklists.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class ClientCheckListsComponent implements OnInit {
  isSearchLoading: boolean = false;
  showFilters:boolean;
  showSorting:boolean;
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  showAddRuleButton:boolean = false;
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  searchParam:IGlobalSearchParam;
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  vcaSearchSpinner = 'vcaSearchSpinner';
  clientCheckLists: any;
  startSearch: boolean = false;
  dialogPosition = 'topright';
  isClientCheckListsAdd : boolean = false;
  isClientCheckListsEdit : boolean = false;
  isClientCheckListsView : boolean = false;
  chkListForm:FormGroup;
  vendorCompanyList: any;
  clientCompanyList: any;
  loading: boolean = false;
  selectedGridMenuItem:any = null;
  items: MenuItem[];
  showToggle:boolean;
  isshowpaginator:boolean=true;
  isCompanyNameSelected:boolean = false;
  buttonLabel: string = "";
  title: string = "";
  statusValues:any;
  selectedStatusId:any="All";
  selectedStatus:any;
   allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'clientCompanyName', header: 'Client Company Name' },
    { value: 'workflowTitle', header: 'Workflow Title' },
    { value: 'checkListName', header: 'Checklist Name' },
    // { value: 'description', header: 'Workflow Title' },
    { value: 'isActive', header: 'Status' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'clientCompanyName', header: 'Client Company Name' },
    { value: 'workflowTitle', header: 'Workflow Title' },
    { value: 'checkListName', header: 'Checklist Name' },
    // { value: 'description', header: 'Workflow Title' },
    { value: 'isActive', header: 'Status' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]
  @ViewChild('dt2', { static: true }) table: any;

  constructor(
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private clientCheckListsService:ClientCheckListsService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private _fb: FormBuilder,
    public sharedService:SharedService,
    private _router: Router,
    private jwtService:JwtService,
  ) { 
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 1000);
    
  }

  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this._router.navigateByUrl('/login');
  }

  ngOnInit(): void {
    this.checkViewPermission();
    this.items = [];
    this.checkEditDeletePermission();
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";
    
    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
        { label: "Not Equals", value: notEquals },
        { label: "Greater Than", value: dateAfter },
        { label: "Less Than", value: dateBefore },
    ];

    this.matchModeOptionsForNumeric = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
      { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];

    this.filterCondition=[
      {fieldName:"clientCompanyName",type:"basic"},
      {fieldName:"workflowTitle",type:"basic"},
      {fieldName:"checkListName",type:"basic"},
      {fieldName:"description",type:"basic"},
      {fieldName:"isActive",type:"basic"},
      {fieldName:"createdBy",type:"basic"},
      {fieldName:"createdOn",type:"date"},
    ];
    

    this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" });
    this.getClientCompanyList();
    this.getClientCheckLists(); 
    this.InitialSetup();
    
    this.statusValues=['All','Active',"Inactive"];
  }

  InitialSetup(){
    this.chkListForm = this._fb.group({
      checkListId: new FormControl(0),
      clientCompanyId: new FormControl(0,[Validators.required]),
      workflowTitle: new FormControl("",[Validators.required]),
      checkListName: new FormControl("",[Validators.required]),
      description: new FormControl(""),
      isActive: new FormControl(true,[Validators.required]),
      createdBy: new FormControl(1),
      createdOn: new FormControl(new Date()),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }

  
  loadClientCheckLists(event:LazyLoadEvent)
  { 
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getClientCheckLists();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
    if(this.filters["createdOn"]!= undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButton = true;
    }
    else{
      this.showAddRuleButton = false;
    }
    }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    /*if(this.sortField !== 'createdOn')
    {
      this.getAllClaimsMasterList()
    }*/

    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getClientCheckLists()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }

  getClientCheckLists(){
    this.searchParam = 
    {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
    };
    this.spinner.show(this.vcaSearchSpinner);
    this.clientCheckListsService.getClientCheckLists(this.searchParam).subscribe(data => {
      // this.appliedFilters = [];
      this.clientCheckLists =data;
      this.isshowpaginator=this.clientCheckLists.length>0?true:false;
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.vcaSearchSpinner);
    }, error => {
      console.log(error);
    })
  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.selectedStatusId = [];
    this.selectedStatus= [];
    // this.applyFilter();
    this.getClientCheckLists();
  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  applyFilterNew(table: Table){
    this.filters=table.filters;
    this.applyFilter();
  }

  applyFilter(){
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              console.log("filter field name is "+[this.filterCondition[i].fieldName][0]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
              if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                this.appliedFilters.push({
                  field: this.filterCondition[i].fieldName,
                  matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                  value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                })
            }
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
    }
    }

    if(this.startSearch == true || this.startSearch == false)
    {
      this.searchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.vcaSearchSpinner);
       this.clientCheckListsService.getClientCheckLists(this.searchParam).subscribe(data => {
        //  this.appliedFilters = [];
         this.clientCheckLists =data;
         this.isshowpaginator=this.clientCheckLists.length>0?true:false;
         this.totalRecords = data[0].totalCount;
         this.spinner.hide(this.vcaSearchSpinner);
       }, error => {
         console.log(error);
       })
    }
  }


  
  getClientCompanyList(){
    this.clientCheckListsService.getClientCompanyList().subscribe(data => {
      this.clientCompanyList = data;
    }, error => {
      console.log(error);
    })
  }
  
  companyNameOnChange(id){
    this.isCompanyNameSelected=true;
  }

  addClientCheckListsDetails(){
    this.InitialSetup();
    this.isClientCheckListsAdd = true;
    this.isClientCheckListsEdit = false;
    this.isClientCheckListsView = false;
    this.title = "Client Checklist Add";
    this.buttonLabel = "Save";
  }

  cancel(){
    this.isClientCheckListsAdd = false;
    this.isClientCheckListsEdit = false;
    this.isClientCheckListsView = false;
  }

  editClientCheckListsDetails(paramId: number)
  {
    this.InitialSetup(); 
    this.isClientCheckListsView=false;
    this.isClientCheckListsEdit = true;
    this.isClientCheckListsAdd = false;
    this.isCompanyNameSelected=true;
    this.title = "Client Checklist Edit";
    this.buttonLabel = "Update";
    this.clientCheckListsService.getClientCheckListIndividual(paramId).subscribe((data:IClientCheckLists) =>{
      this.chkListForm.patchValue(data);
      console.log(data);
    },error => {
      console.log(error)
    })
  }

  save({value}: {value:IClientCheckLists}){
    this.spinner.show(this.vcaSearchSpinner);
    this.loading = true;
    

    if(value.checkListId==0){
      value.createdBy = this.jwtService.getLoggedInUserProfileId();
      value.createdOn = new Date();
      value.modifiedBy = this.jwtService.getLoggedInUserProfileId();
      value.modifiedOn = new Date();
        this.clientCheckListsService.postClientCheckLists(value).subscribe(data=>{
          this.isClientCheckListsAdd = false;
          this.getClientCheckLists();
          this.loading = false;
          this.spinner.hide(this.vcaSearchSpinner);
        }, error => {
          console.log(error);
        })
    }
    else{
      value.modifiedBy = this.jwtService.getLoggedInUserProfileId();
      value.modifiedOn = new Date();
      this.clientCheckListsService.updateClientCheckLists(value.checkListId, value).subscribe(data => {
        this.isClientCheckListsEdit = false;
        this.getClientCheckLists();
        this.loading = false;
          this.spinner.hide(this.vcaSearchSpinner);
      }, error => {
        console.log(error);
      })
     }
     

  }

  
  deleteConfirm(paramId:number){
    this.dialogPosition = 'topright';
    this.confirmationService.confirm({
      message: 'Do you want to delete this Vendor Client Assignment?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.clientCheckListsService.deleteClientCheckListsDetail(paramId).subscribe((data: any) => {
          this.getClientCheckLists();
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have deleted the record'});
         });
      },
      reject: (type) => {
        switch(type) {
            case ConfirmEventType.REJECT:
                this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
            break;
            case ConfirmEventType.CANCEL:
                this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
            break;
        }
      },
      key: "positionDialog"
    });
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }

  checkEditDeletePermission() {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if (isAdminAdd) {
      var editItem = {
        label:'Edit',
       icon:'pi pi-fw pi-pencil',
       command: e => this.editClientCheckListsDetails(this.selectedGridMenuItem.checkListId)
      }
      this.items.push(editItem)
    }
    if(isAdminDelete){
      var deleteItem =  {
        label:'Delete',
        icon:'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.checkListId)
       }
       this.items.push(deleteItem);
    }
  }


  get chkListFormControl() {
    return this.chkListForm.controls;
  }
  
  getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }

}
